import * as types from "./mutations-types";

export default {
    [types.UPDATE_REFRESH](state) {
        state.refresh = state.refresh + 1;
    }
};
